import React, { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../AuthContextWrapper";
import { OUTCOMES } from "../../../constants";
import { Box, Typography } from "@mui/material";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";
import { ScreenFlowFormButtons } from "../shared/ScreenFlowFormButtons";
import usaImage1 from "../../assets/usa-star-1x.png";
import usaImage15 from "../../assets/usa-star-1.5x.png";
import usaImage2 from "../../assets/usa-star-2x.png";
import usaImage3 from "../../assets/usa-star-3x.png";
import canadaImage1 from "../../assets/canada-flag-1x.png";
import canadaImage15 from "../../assets/canada-flag-1.5x.png";
import canadaImage2 from "../../assets/canada-flag-2x.png";
import canadaImage3 from "../../assets/canada-flag-3x.png";

export enum Outcomes {
  continue = "Continue",
}

const VetCountryIcon = (): JSX.Element => {
  const { user } = useContext(AuthContext);
  const userCountryId = user?.profile?.countryId;
  if (userCountryId == "1") {
    return (
      <img
        srcSet={`${usaImage15} 1.5x, ${usaImage2} 2x, ${usaImage3} 3x`}
        src={usaImage1}
        alt="USA Flag in a Star Shape"
        style={{ height: "156px" }}
      />
    );
  } else if (userCountryId == "2") {
    return (
      <img
        srcSet={`${canadaImage15} 1.5x, ${canadaImage2} 2x, ${canadaImage3} 3x`}
        src={canadaImage1}
        alt="Canadian Flag"
        style={{ height: "156px" }}
      />
    );
  } else {
    return <></>;
  }
};

export const VetAppreciationScreen = (): JSX.Element => {
  const navigate = useNavigate();
  const { flow, activeEstate } = useContext(AuthContext);
  const { screenName } = useParams();
  const currentScreen = flow?.getCurrentFlowScreen(screenName);

  const handleComplete = async (): Promise<boolean> => {
    if (!currentScreen) throw Error("couldn't determine currentScreen");

    flow?.navigateToNext(currentScreen, OUTCOMES.complete, navigate);
    return true;
  };

  return currentScreen ? (
    <FlowScreenWrapper title={""}>
      <Box>
        <VetCountryIcon />
        <Typography component="h2" variant="h5">
          On behalf of the Atticus team, we appreciate{" "}
          {activeEstate?.deceasedFirstName}'s sacrifice and service.
        </Typography>
        {/* <Typography variant="body1" sx={{ mt: 1, mb: 4, maxWidth: 580 }}>
          We'll be extending your family a Veteran discount that you can use for
          any of our paid Atticus plans.
        </Typography> */}
        <form onSubmit={handleComplete}>
          <ScreenFlowFormButtons onBack={() => navigate(-1)} />
        </form>
      </Box>
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
